import { environment } from 'src/environments/environment';

export const API = {
  // auth
  LOGIN: environment.module.cooperative + '/api/auth/login',
  REGISTER: environment.module.cooperative + '/api/auth/register',

  // cooperative
  COOPERATIVE: environment.module.cooperative + '/api/cooperative',
  COOPERATIVE_IMPORT: environment.module.cooperative + '/api/cooperative/import-from-file',
  COOPERATIVE_IMPORT_TEMPLE_DOWNLOAD: environment.module.cooperative + '/api/cooperative/download-import-template',
  COOPERATIVE_DETAIL: environment.module.cooperative + '/api/cooperative/:cooperativeNo',
  COOPERATIVE_SEARCH: environment.module.cooperative + '/api/cooperative/search',
  COOPERATIVE_LIST: environment.module.cooperative + '/api/cooperative/list',
  COOPERATIVE_DELETE: environment.module.cooperative + '/api/cooperative/delete',
  COOPERATIVE_CODE_UNIQUE_CHECK: environment.module.cooperative + '/api/cooperative/unique-cooperative-code',
  COOPERATIVE_OVERVIEW: environment.module.cooperative + '/api/cooperative/overview',
  COOPERATIVE_CLOSING_METER_DATA: environment.module.cooperative + '/api/cooperative/manual-close-meter-data',

  // station
  STATION: environment.module.cooperative + '/api/station',
  STATION_DETAIL: environment.module.cooperative + '/api/station/:stationNo',
  STATION_LIST: environment.module.cooperative + '/api/station/list',
  STATION_DELETE: environment.module.cooperative + '/api/station/delete',
  STATION_CODE_UNIQUE_CHECK: environment.module.cooperative + '/api/station/unique-station-code',
  STATION_METER_DATA_EXPORT_PREVIEW: environment.module.cooperative + '/api/station/:stationNo/meter-data/preview-export',
  STATION_METER_DATA_EXPORT: environment.module.cooperative + '/api/station/:stationNo/meter-data/export',

  // user
  USER_DEACTIVATE: environment.module.cooperative + '/api/user/delete',
  USER_NAME_UNIQUE_CHECK: environment.module.cooperative + '/api/auth/user/unique-user-name',

  // customer
  CUSTOMER_SEARCH: environment.module.cooperative + '/api/customer/search',
  CUSTOMER_DETAIL: environment.module.cooperative + '/api/customer/:customerNo',
  CUSTOMER: environment.module.cooperative + '/api/customer',
  CUSTOMER_DELETE: environment.module.cooperative + '/api/customer/delete',
  CUSTOMER_CODE_UNIQUE_CHECK: environment.module.cooperative + '/api/customer/unique-customer-code',
  CUSTOMER_METER_CODE_UNIQUE_CHECK: environment.module.cooperative + '/api/customer/unique-meter-code',
  CUSTOMER_MEASURING_POINT_CODE_UNIQUE_CHECK: environment.module.cooperative + '/api/customer/unique-measuring-point-code',
  CUSTOMER_IMPORT: environment.module.cooperative + '/api/customer/import-from-file',
  CUSTOMER_IMPORT_TEMPLE_DOWNLOAD: environment.module.cooperative + '/api/customer/download-import-template',
  CUSTOMER_METER_DATA_VIEW: environment.module.cooperative + '/api/meter-data/view',
  CUSTOMER_METER_DATA_HISTORY: environment.module.cooperative + '/api/meter-data/history',
};
